<template>
  <div class="custom-bg-hero-section" v-if="headline">
    <div class="custom-bg-hero-section__container">
      <h1 class="custom-bg-hero-section__headline">
        {{ headline }}
      </h1>

      <div class="custom-bg-hero-section__subheadline" v-html="subheadline" />
    </div>

    <pict
      block-name="custom-bg-hero-section"
      :default="{
        src: $options.image[$i18n.locale].l,
        srcset: {
          '2x': $options.image[$i18n.locale].l2x
        }
      }"
      :alt="headline"
    />
  </div>
</template>

<script>
import Pict from "@/shared/pict"
import imageLEn from "../images/illustration_en.png"
import imageL2xEn from "../images/illustration_en@2x.png"
import imageLDe from "../images/illustration_de.png"
import imageL2xDe from "../images/illustration_de@2x.png"

export default {
  name: "CustomBgHeroSection",
  components: {
    Pict
  },
  props: {
    headline: {
      type: String,
      default: null
    },
    subheadline: {
      type: String,
      default: null
    }
  },
  image: {
    en: {
      l: imageLEn,
      l2x: imageL2xEn
    },
    de: {
      l: imageLDe,
      l2x: imageL2xDe
    },
    es: {
      l: imageLEn, // update to imageLEs once we have the images!
      l2x: imageL2xEn // imageL2xEs once we have the images!
    }
  }
}
</script>

<style lang="scss">
.custom-bg-hero-section {
  color: $white;

  background-color: $blue;

  &__container {
    padding: $spacing-16 $spacing-16 0;
  }

  &__headline {
    @include font-style(h2, $color: $white);

    margin-bottom: $spacing-24;

    text-align: center;
  }

  &__subheadline {
    margin-bottom: $spacing-32;

    text-align: center;
  }

  &__image {
    display: block;
    width: 100%;

    background-color: $blue;
  }
}
</style>
